/*@ngInject*/
const UIWidgetGridScrollManagerDirective = function ($timeout) {

    let linkFunction = function ($scope, $elm) {

        let element = $($elm),
            gridContainer = element.find('.scrollVerticalContainer'),
            scrollTimer,
            isIe11 = $('body').hasClass('ie11');

        function cancelExistingTimeout() {
            if (scrollTimer) {
                $timeout.cancel(scrollTimer);
            }
        }

        function handleScroll(event) {
            let newWidth = element.width() + event.target.scrollLeft;
            gridContainer.css('width', newWidth);

            function hideScrollBarOnScroll() {
                gridContainer.css('overflow-y', 'hidden');

                cancelExistingTimeout();

                scrollTimer = $timeout(function () {
                    gridContainer.css('overflow-y', 'auto');
                }, 150);
            }

            if (isIe11) {
                hideScrollBarOnScroll();
            }
        }

        element.on('scroll', handleScroll);

        $scope.$on('$destroy', function () {
            element.off('scroll', handleScroll);
            cancelExistingTimeout();
        });
    };

    return {
        restrict: 'A',
        link: linkFunction,
        scope: {}
    };
};

angular.module('umLanding')
    .directive('uiWidgetGridScrollManager', UIWidgetGridScrollManagerDirective);
